/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./Header"
import Footer from "./Footer"

import { JsonCreatorPlugin } from "gatsby-tinacms-json"
import { withPlugin } from "tinacms"
import { slugify } from "./Helpers"

import { useFormScreenPlugin } from 'tinacms'
import { useJsonForm } from 'gatsby-tinacms-json'
import { NavigationForm } from "./Navigation"



const CreateBlogButton = new JsonCreatorPlugin({
    label: "New Blog Post",
    filename(form) {
        let slug = slugify(form.slug)
        return `content/posts/${slug}.json`
    },
    fields: [
        { name: "title", label: "Title", component: "text", required: true },
        { name: "slug", label: "Slug", component: "text", required: true },

    ],
    data(form) {
        let slug = slugify(form.slug)
        alert('Page Created!')
        return {
            title: form.title,
            slug: slug,
            published: false,
            created_at: Date.now(),
            body: "-- Add post content here. Don't forget to click on the pencil bottom left of the page and hit save when finished --"
        }
    },
})

const CreateFAQButton = new JsonCreatorPlugin({
    label: "New FAQ",
    filename(form) {
        let slug = slugify(form.path)
        return `content/faqs/${slug}.json`
    },
    fields: [
        { name: "title", label: "Title", component: "text", required: true },
        { 
            name: "path", 
            label: "Path", 
            component: "text", 
            required: true,
            description: `Important! Once you create this page, click on the hamburger icon on the editing sidebar -> Menu -> FAQs and create a new FAQ submenu with this path in the link field to make this newly created page reachable within the site`
        },
    ],
    data(form) {
        let path = "/" + slugify(form.path)
        alert(`Page Created! Add '${form.path}' to sidebar -> Menu -> FAQs submenu`)
        return {
            title: form.title,
            path: path,
        }
    },
})

const Layout = ({ children }) => {
    const data = useStaticQuery(graphql`
    query SiteTitleQuery {
        site: settingsJson(
            fileRelativePath: { eq: "/content/settings/site.json" }
          ) {
            title
            description
    
            rawJson
            fileRelativePath
        }
        nav: settingsJson(
            fileRelativePath: { eq: "/content/settings/menu.json" }
          ) {
            menuItems {
                label
                link
                submenuItems {
                    label
                    link
                }
            }
            
            rawJson
            fileRelativePath
        }
    }
  `)

    // Create the form
    const [, form1] = useJsonForm(data.site, SiteForm)
    const [, form2] = useJsonForm(data.nav, NavigationForm)

    // Register it as a Screen with the CMS
    useFormScreenPlugin(form1)
    useFormScreenPlugin(form2)

    return (
        <>
            <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
            {children}
            <Footer />
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default withPlugin(Layout, [CreateBlogButton, CreateFAQButton])

const SiteForm = {
    label: "Site",
    fields: [
        {
            label: "Title",
            name: "rawJson.title",
            component: "text",
            parse(value) {
                return value || ""
            },
        },
        {
            label: "Description",
            name: "rawJson.description",
            component: "textarea",
            parse(value) {
                return value || ""
            },
        },
    ],
}